import SVG from "shared/SVG";
import "./Footer.scss";
import { ROUTE_ENUM, SVG_ENUM } from "enums";
import { useNavigate } from "react-router";
import { SocialIcons } from "shared";
import { Tooltip } from "react-tooltip";
import { isDesktop } from "utils";

const FooterTooltipContent: React.FC = () => (
  <div>
    <p>
      Informacje prezentowane w aplikacji app.reliance.pro mają wyłącznie
      charakter informacyjny i służą wsparciu procesu długoterminowego
      planowania finansowego. Nie stanowią one oferty w rozumieniu art. 66 §1
      ani art. 66¹ Kodeksu cywilnego, oferty nabycia lub zbycia jakichkolwiek
      aktywów lub instrumentów finansowych, ani rekomendacji inwestycyjnej,
      porady prawnej czy podatkowej.
    </p>
    <p>
      Aplikacja app.reliance.pro
      <b> nie służy do sprzedawania aktywów ani do zawierania transakcji</b> –
      za jej pośrednictwem Reliance Holding nie przyjmuje wiążących oświadczeń
      woli klientów, w szczególności zleceń kupna lub sprzedaży aktywów oraz
      dyspozycji dotyczących rachunków pieniężnych czy papierów wartościowych.
    </p>
    <p>
      Informacji zawartych w niniejszej aplikacji nie należy traktować jako
      porady inwestycyjnej, oferty lub rekomendacji zawarcia transakcji.
      Produkty inwestycyjne są obarczone ryzykiem inwestycyjnym, włącznie z
      możliwością utraty całości lub części zainwestowanego kapitału. Spółka nie
      ponosi odpowiedzialności za ewentualne szkody, jakie może ponieść Klient w
      wyniku zawarcia transakcji ze spółką na podstawie niniejszych informacji.
      Wszelkie decyzje inwestycyjne klienci podejmują samodzielnie i na własną
      odpowiedzialność, po zapoznaniu się z pełną dokumentacją danej inwestycji
      oraz – w razie potrzeby – po zasięgnięciu indywidualnej porady doradcy
      prawnego, podatkowego lub inwestycyjnego.
    </p>
  </div>
);

const Footer: React.FC = () => {
  const navigate = useNavigate();
  const isDesktopDevice = isDesktop();

  const tooltipPlace = isDesktopDevice ? "top" : "bottom";

  const navigateAndScrollToTop = (route: ROUTE_ENUM) => {
    navigate(route);
    window.scrollTo(0, 0);
  };

  return (
    <>
      <Tooltip
        id="company-tooltip"
        place={tooltipPlace}
        className="custom-tooltip-footer"
        render={() => <FooterTooltipContent />}
      />
      <footer className="footer">
        <div className="layout footer__content">
          <div className="footer__left">
            <span
              className="footer__logo"
              onClick={() => navigate(ROUTE_ENUM.HOME)}
            >
              <SVG type={SVG_ENUM.LOGO_WHITE} />
            </span>
            <div className="footer--show-desktop">
              <div className="footer__see-our-site">
                <p>Odwiedź naszą stronę:</p>
                <a href="https://reliance.pro" target="_blank" rel="noreferrer">
                  https://reliance.pro
                </a>
              </div>
              <div>
                <p>Zaobserwuj nas na:</p>
                <SocialIcons />
              </div>
            </div>
          </div>
          <div className="footer__mid">
            <p>
              Aplikacja app.reliance.pro nie służy do sprzedawania aktywów ani
              zawierania transakcji. Prezentowane w niej dane mają wyłącznie
              charakter informacyjny, nie stanowią oferty w rozumieniu art. 66
              §1 Kodeksu cywilnego ani rekomendacji inwestycyjnej.
              <span
                className="footer__mid-icon footer__tooltip-trigger"
                data-tooltip-id="company-tooltip"
              >
                <SVG type={SVG_ENUM.INFO} />
              </span>
            </p>
          </div>
          <div className="footer__right">
            <div className="footer__columns">
              <div className="footer__links">
                <p
                  onClick={() =>
                    isDesktopDevice
                      ? window.open(ROUTE_ENUM.TERMS_OF_SERVICE, "_blank")
                      : navigateAndScrollToTop(ROUTE_ENUM.TERMS_OF_SERVICE)
                  }
                >
                  Regulamin
                </p>
                <p
                  onClick={() =>
                    isDesktopDevice
                      ? window.open(ROUTE_ENUM.PRIVACY_POLICY, "_blank")
                      : navigateAndScrollToTop(ROUTE_ENUM.PRIVACY_POLICY)
                  }
                >
                  Polityka prywatności
                </p>
              </div>
              <div className="footer__address">
                <div>
                  <p>al. 29 Listopada 39E/U3</p>
                  <p>31-425 Kraków</p>
                </div>
                <div>
                  <p>+48 123 450 744</p>
                  <p>
                    <a href="mailto:biuro@reliance.pro">biuro@reliance.pro</a>
                  </p>
                </div>
              </div>
              <div className="footer--show-tablet">
                <div className="footer__see-our-site">
                  <p>Odwiedź naszą stronę:</p>
                  <a
                    href="https://reliance.pro"
                    target="_blank"
                    rel="noreferrer"
                  >
                    https://reliance.pro
                  </a>
                </div>
                <div>
                  <p>Zaobserwuj nas na:</p>
                  <SocialIcons />
                </div>
              </div>
            </div>
            <div className="footer__law">
              <p>© 2024 Reliance Holding. Wszelkie prawa zastrzeżone</p>
              <p>
                Website by{" "}
                <a
                  target="_blank"
                  href="https://korg.software"
                  rel="noreferrer"
                >
                  korg.software
                </a>
              </p>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
